<template>
  <div class="app-header" key="card">
    <div class="header-top">
      <div class="header-branding">
        <img src="../assets/SwiftAI logo - 2026.svg" alt="Swift" class="brand-logo" />
      </div>

      <div class="header-actions">
        <button
          class="new-app-btn"
          type="button"
          @click="onNewAppClick"
          :disabled="!larLoaded"
        >
          New Application
        </button>

        <ProfileCardMenu
          :azure-id="azureId"
          :token="token?.accessToken"
          :show-impersonate="showImpersonate"
          :impersonating="impersonating"
          @open-impersonate="showuserslist"
          @stop-impersonate="stopImpersonate"
          @logout="deepLogout"
        />
      </div>
    </div>

    <div class="header-nav">
      <div class="nav-links">
        <router-link to="/" class="nav-link">Command Center</router-link>

        <router-link to="/Applications" class="nav-link hide-on-mobile">
          Applications
        </router-link>

        <router-link to="/Processing" class="nav-link">Pipeline</router-link>

        <router-link v-if="isPostClosing" to="/PostCloseConnect" class="nav-link hide-on-mobile">
          swiftPC
        </router-link>

        <router-link v-if="isCorp" to="/Insights" class="nav-link hide-on-mobile">
          swiftUW
        </router-link>

        <!-- Ungated on purpose: any LO may need to request a concession, and the
             page self-gates off the Polly access roster (concession_approvers).
             Someone who cannot request gets an explanation, not a broken form. -->
        <router-link to="/concessions" class="nav-link hide-on-mobile">
          Concessions
        </router-link>

        <div v-if="canViewRepricedLocks" class="nav-dropdown hide-on-mobile">
          <span class="nav-link nav-dropdown-trigger"
                :class="{ 'router-link-active': isSwiftLocksActive }">
            swiftLocks <i class="fa-solid fa-chevron-down nav-chevron"></i>
          </span>
          <div class="nav-dropdown-menu">
            <router-link to="/lock-desk-queue" class="nav-dropdown-item">Work Queue</router-link>
            <router-link to="/reprice" class="nav-dropdown-item">Lock Reprice</router-link>
            <router-link to="/extensions" class="nav-dropdown-item">Lock Extensions</router-link>
            <router-link to="/lock-extension-request" class="nav-dropdown-item">Extension Request</router-link>
            <router-link to="/loan-price-sheet" class="nav-dropdown-item">Price Sheet</router-link>
          </div>
        </div>
        <div v-if="canViewHmda" class="nav-dropdown hide-on-mobile">
          <span class="nav-link nav-dropdown-trigger"
                :class="{ 'router-link-active': isSwiftComplyActive }">
            swiftComply <i class="fa-solid fa-chevron-down nav-chevron"></i>
          </span>
          <div class="nav-dropdown-menu">
                    <div class="nav-submenu">
              <span class="nav-dropdown-item nav-submenu-trigger">
                 Disclosures<i class="fa-solid fa-chevron-right nav-submenu-chevron"></i>
              </span>
              <div class="nav-submenu-menu">
              
                <router-link to="/ICD" class="nav-dropdown-item">ICD</router-link>
              </div>
            </div>
            <!-- ── Loan Status Disclosures ── -->
            <div class="nav-submenu">
              <span class="nav-dropdown-item nav-submenu-trigger">
                 Loan Status  <i class="fa-solid fa-chevron-right nav-submenu-chevron"></i>
              </span>
              <div class="nav-submenu-menu">
                <router-link to="/hmda-withdrawals" class="nav-dropdown-item">Loan Status</router-link>
              
              </div>
            </div>

            <!-- ── Insuring ── -->
            <div class="nav-submenu">
              <span class="nav-dropdown-item nav-submenu-trigger">
                Insuring <i class="fa-solid fa-chevron-right nav-submenu-chevron"></i>
              </span>
              <div class="nav-submenu-menu">
                <router-link to="/ai-insuring" class="nav-dropdown-item">Closing Packages</router-link>
                <router-link to="/Insuring" class="nav-dropdown-item">Upload FHA MIP</router-link>
                <router-link to="/fha-mip-payments" class="nav-dropdown-item">FHA MIP Payments</router-link>
              </div>
            </div>
          </div>
        </div>
      
    

        <a
          v-if="isCorp"
          :href="applicationAdminLink"
          target="_blank"
          class="nav-link hide-on-mobile"
        >
          Application Admin
        </a>

        <router-link to="/NotificationManagement" class="nav-link hide-on-mobile">
          Notification Management
        </router-link>
      </div>
    </div>
  </div>

  <!-- Application Type Picker Modal -->
  <transition name="modal-fade">
    <div v-if="showAppTypePicker" class="app-type-overlay" @click.self="showAppTypePicker = false">
      <div class="app-type-modal">
        <div class="app-type-header">
          <h2 class="app-type-title">Start New Application</h2>
          <p class="app-type-subtitle">Select the type of application to begin</p>
          <button class="app-type-close" @click="showAppTypePicker = false">
            <i class="fa-regular fa-xmark"></i>
          </button>
        </div>
        <div class="app-type-options">
          <button class="app-type-card" @click="onSelectRegularApp">
            <div class="app-type-icon">
              <i class="fa-light fa-file-signature"></i>
            </div>
            <div class="app-type-info">
              <p class="app-type-name">Standard</p>
              <p class="app-type-desc">Forward mortgage loan application via swiftApp</p>
            </div>
            <i class="fa-light fa-arrow-right app-type-arrow"></i>
          </button>

          <button class="app-type-card" @click="onSelectReverseMortgage">
            <div class="app-type-icon reverse">
              <i class="fa-light fa-house-chimney"></i>
            </div>
            <div class="app-type-info">
              <p class="app-type-name">Reverse</p>
              <p class="app-type-desc">Initial intake form for submission to the reverse mortgage team</p>
            </div>
            <i class="fa-light fa-arrow-right app-type-arrow"></i>
          </button>

          <button class="app-type-card" @click="onSelectCommercialLoan">
            <div class="app-type-icon commercial">
              <i class="fa-light fa-building-columns"></i>
            </div>
            <div class="app-type-info">
              <p class="app-type-name">Commercial</p>
              <p class="app-type-desc">Commercial loan intake for multifamily, retail, office, industrial &amp; more</p>
            </div>
            <i class="fa-light fa-arrow-right app-type-arrow"></i>
          </button>
        </div>
      </div>
    </div>
  </transition>

  <Dialog v-if="showHelp" :title="'How to Complete Application'" @close="showHelp = false">
    <div class="help-modal">
      <div v-if="helpFrameLoading" class="iframe-loader">
        <i class="fa-solid fa-spinner fa-spin"></i>
        Loading training video...
      </div>

      <iframe
        class="help-frame"
        src="https://embed.app.guidde.com/playbooks/mXxqZoCQvHE58P3S2dAXqX?mode=videoOnly"
        frameborder="0"
        allowfullscreen
        @load="helpFrameLoading = false"
      ></iframe>
    </div>
  </Dialog>

  <Dialog v-if="pickAUser" :title="'Impersonate User'" @close="onClose" class="imper">
    <div class="p-4 space-y-4">
      <dropdownlist
        v-if="pickAUser"
        :data-items="filteredUsers"
        :value="selectedAssignees"
        @change="onAssigneeChange"
        :filterable="true"
        @filterchange="onFilterAssigneeChange"
        :text-field="'displayName'"
        :data-item-key="'id'"
        :disabled="filteredUsers.length === 0 || switchingUser"
        :loading="filterUsersLoading || switchingUser"
        class="task__form__multi"
        placeholder=""
        :rounded="'large'"
        :fill-mode="'outline'"
        :label="'Select a user to impersonate'"
        :style="{ width: '250px' }"
      />

      <div v-if="switchingUser" class="impersonate-status">
        <i class="fa-solid fa-spinner fa-spin"></i>
        Switching user...
      </div>
    </div>
  </Dialog>

  <gsai-window :visible="showAi" :url="url" @toggleAIDialog="closegsai" />
</template>

<script>
import apiService from "../api/api.service.js"
import { Button } from "@progress/kendo-vue-buttons"
import auth from "../authConfig.js"
import gsai from "./gsAiWindow.vue"
import ProfileCardMenu from "@/components/UserProfileMenu.vue"
import { DropDownList } from "@progress/kendo-vue-dropdowns"
import { Dialog } from "@progress/kendo-vue-dialogs"
import { filterBy } from "@progress/kendo-data-query"
import bus from "@/helpers/appBus.js"

export default {
  data() {
    return {
      userRoles: [],
      activeUserRoles: [],
      isAppBeta: false,
      isCorp: false,
      isPostClosing: false,
      canViewRepricedLocks: false,
      canViewHmda: false,
      showAi: false,
      showHelp: false,
      helpFrameLoading: false,
      showAppTypePicker: false,
      url: "",
      lar: "",
      larLoaded: false,
      token: "",
      azureId: "",
      filteredUsers: [],
      fetchedUsers: [],
      selectedAssignees: null,
      pickAUser: false,
      showImpersonate: false,
      impersonating: false,
      filterUsersLoading: false,
      switchingUser: false
    }
  },
  computed: {
    applicationAdminLink() {
      let appSiteUrl = process.env.VUE_APP_LOANLAUNCH_APP_ENDPOINT
      return `${appSiteUrl}/applicationAdmin`
    },
    isSwiftLocksActive() {
      const path = this.$route?.path || ''
      return ['/reprice', '/lock-desk-queue', '/extensions', '/lock-extension-request', '/loan-price-sheet']
        .some(p => path.startsWith(p))
    },
    isSwiftComplyActive() {
      const path = this.$route?.path || ''
      return ['/hmda-withdrawals', '/ICD', '/ai-insuring', '/Insuring', '/fha-mip-payments']
        .some(p => path.startsWith(p))
    }
  },
  components: {
    "k-button": Button,
    "gsai-window": gsai,
    dropdownlist: DropDownList,
    Dialog,
    ProfileCardMenu
  },
  async mounted() {
    this.token = await auth.acquireTokenResponse()
    this.loadContext()
    bus.on("auth-context-ready", this.onAuthContextReady)
    await this.getLar()
  },
  beforeUnmount() {
    bus.off("auth-context-ready", this.onAuthContextReady)
  },
  methods: {
    openHelp() {
      this.helpFrameLoading = true
      this.showHelp = true
    },
    onAuthContextReady() {
      this.switchingUser = false
      this.loadContext()
      this.getLar()
    },
    loadContext() {
      this.azureId = localStorage.getItem("azure_id") || ""
      this.impersonating = !!localStorage.getItem("imp_azureid")
      this.userRoles = this.getRolesFromStorage("user_roles")
      this.activeUserRoles = this.getRolesFromStorage("active_user_roles")
      this.showImpersonate = this.rolesInclude(this.userRoles, "Impersonation")
      this.applyNavPermissions(this.activeUserRoles)
    },
    getRolesFromStorage(key) {
      const raw = localStorage.getItem(key)
      if (!raw) return []

      try {
        const parsed = JSON.parse(raw)
        if (Array.isArray(parsed)) {
          return parsed.map(x => String(x || "").trim()).filter(Boolean)
        }

        return String(parsed || "")
          .split(",")
          .map(x => String(x || "").trim())
          .filter(Boolean)
      } catch {
        return String(raw || "")
          .split(",")
          .map(x => String(x || "").trim())
          .filter(Boolean)
      }
    },
    rolesInclude(roles, role) {
      const target = String(role || "").toLowerCase().trim()
      return (roles || [])
        .map(x => String(x || "").toLowerCase().trim())
        .includes(target)
    },
    applyNavPermissions(roles) {
      this.isCorp = this.rolesInclude(roles, "Corp")
      this.isPostClosing =
        this.rolesInclude(roles, "Post Closer") || this.rolesInclude(roles, "Corp")
      this.isAppBeta =
        this.rolesInclude(roles, "APPBETA") || this.rolesInclude(roles, "Corp")
      this.canViewRepricedLocks = this.rolesInclude(roles, "Compensation Admin")
      this.canViewHmda = this.rolesInclude(roles, "Corp") || this.rolesInclude(roles, "HMDA")
    },
    onClose() {
      if (this.switchingUser) return
      this.pickAUser = false
      this.clearImpersonateDialogState()
    },
    clearImpersonateDialogState() {
      this.selectedAssignees = null
      this.filteredUsers = [...this.fetchedUsers]
      this.filterUsersLoading = false
    },
    async stopImpersonate() {
      this.switchingUser = true
      this.pickAUser = false
      this.clearImpersonateDialogState()
      localStorage.setItem("imp_azureid", "")
      bus.emit("auth-context-request")
      await this.$router.push("/")
    },
    async onAssigneeChange(e) {
      if (this.switchingUser) return
      const value = e.target.value
      this.selectedAssignees = value

      this.switchingUser = true
      this.pickAUser = false
      this.clearImpersonateDialogState()

      localStorage.setItem("imp_azureid", value.id)
      bus.emit("auth-context-request")
      await this.$router.push("/")
    },
    onFilterAssigneeChange(e) {
      this.filterUsersLoading = true
      this.filteredUsers = filterBy(this.fetchedUsers, e.filter)
      this.filterUsersLoading = false
    },
    async showuserslist() {
      if (this.switchingUser) return
      await this.getImpersonateUsers()
      this.pickAUser = true
    },
    async getImpersonateUsers() {
      return apiService
        .GetImpersonableUsers(this.azureId, this.token.accessToken)
        .then(res => {
          if (res.data?.data) {
            const sorted = [...res.data.data].sort((a, b) =>
              a.displayName.localeCompare(b.displayName)
            )
            this.fetchedUsers = sorted
            this.filteredUsers = sorted
          }
        })
        .catch(() => {})
    },
    async getLar() {
      this.larLoaded = false
      try {
        const cached = localStorage.getItem("user_azure_data")
        if (cached) {
          const parsed = JSON.parse(cached)
          this.lar = parsed?.onPremisesExtensionAttributes?.extensionAttribute1 ?? null
          this.larLoaded = this.lar !== null
          return
        }

        const result = await apiService.GetUsersAzureData(this.azureId, this.token.accessToken)
        this.lar = result?.data?.data?.onPremisesExtensionAttributes?.extensionAttribute1 ?? null
        this.larLoaded = this.lar !== null
      } catch {
        this.lar = null
        this.larLoaded = false
      }
    },
    // Intercept the New Application click — show picker instead of going direct
    onNewAppClick() {
      this.showAppTypePicker = true
    },
    onSelectRegularApp() {
      this.showAppTypePicker = false
      window.open(`https://apply.loanlaunch.com/application?lar=${this.lar}`, "_blank")
    },
    onSelectReverseMortgage() {
      this.showAppTypePicker = false
      const base = window.location.origin + (process.env.BASE_URL || "/")
      window.open(`${base}reverse-mortgage`, "_blank")
    },
    onSelectCommercialLoan() {
      this.showAppTypePicker = false
      const base = window.location.origin + (process.env.BASE_URL || "/")
      window.open(`${base}application-commercial`, "_blank")
    },
    closegsai() {
      this.showAi = false
    },
    deepLogout() {
      auth.logout()
    }
  }
}
</script>

<style scoped>
.small-header{
  font-size: 10px;
}
.app-header {
  border-bottom: 0;
  background: var(--background);
  color: var(--on-background);
  position: relative;
  z-index: 20;
  box-sizing: border-box;
  font-family: var(--bs-font-sans-serif);
  -webkit-font-smoothing: antialiased;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 0;
  padding-bottom: 0;
  min-width: 100%;
  background: var(--background);
  color: var(--on-background);
}

.brand-logo {
  width: 100%;
  max-width: 250px;
  height: 37.58px;
  padding-left: 15px;
}

.header-actions {
  display: flex;
  align-items: center;
  font-size: 1.8rem;
}

.new-app-btn {
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.14);
  background: rgba(255, 255, 255, 0.9);
  color: var(--primary);
  font-weight: 600;
  font-size: 1.3rem;
  padding: 0 14px;
  height: 36px;
  cursor: pointer;
  line-height: 1;
}

.new-app-btn:hover {
  background: rgba(15, 23, 42, 0.05);
}

.new-app-btn:disabled {
  background: var(--kendo-button-bg);
  color: #999;
  cursor: not-allowed;
}

.header-nav {
  background: var(--background);
  border-bottom: 0.3rem solid var(--accent);
  padding: 1rem 1rem 0;
  padding-bottom: 5px;
}

.nav-links {
  display: flex;
  align-items: baseline;
  gap: 20px;
}

.nav-link {
  text-decoration: none;
  color: var(--primary);
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1.4285714286;
  letter-spacing: 0;
  padding: 6px 12px;
  margin: 0;
  font-family: Segoe UI;
}

.nav-link:hover {
  color: var(--text-secondary-on-background);
}

.hide-on-mobile {
  display: inline-flex;
}

/* ── Application Type Picker Modal ── */
.app-type-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(5, 29, 58, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.app-type-modal {
  background: var(--background);
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 24px 60px rgba(5, 29, 58, 0.22);
  overflow: hidden;
}

.app-type-header {
  padding: 24px 24px 20px;
  position: relative;
  border-bottom: 1px solid var(--secondary-ltr);
}

.app-type-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--primary);
  margin: 0 0 4px;
  font-family: Segoe UI, sans-serif;
}

.app-type-subtitle {
  font-size: 1.3rem;
  color: var(--text-secondary-on-background);
  margin: 0;
  font-family: Segoe UI, sans-serif;
}

.app-type-close {
  position: absolute;
  top: 18px;
  right: 18px;
  background: none;
  border: none;
  font-size: 1.8rem;
  color: var(--text-secondary-on-background);
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.app-type-close:hover {
  background: var(--background-dk);
  color: var(--primary);
}

.app-type-options {
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.app-type-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 12px;
  border: 1.5px solid var(--secondary-ltr);
  background: var(--background);
  cursor: pointer;
  text-align: left;
  width: 100%;
  transition: all 0.18s ease;
}

.app-type-card:hover {
  border-color: var(--accent);
  background: var(--accent-ltst);
  box-shadow: 0 4px 16px rgba(57, 139, 135, 0.12);
  transform: translateY(-1px);
}

.app-type-card:hover .app-type-arrow {
  transform: translateX(4px);
  color: var(--accent);
}

.app-type-icon {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  background: var(--primary-ltr);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  flex-shrink: 0;
}

.app-type-icon.reverse {
  background: var(--accent-ltr);
  color: var(--accent-dk);
}

.app-type-icon.commercial {
  background: #eff1f5;
  color: #475569;
}

.app-type-info {
  flex: 1;
  min-width: 0;
}

.app-type-name {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary);
  margin: 0 0 3px;
  font-family: Segoe UI, sans-serif;
}

.app-type-desc {
  font-size: 1.25rem;
  color: var(--text-secondary-on-background);
  margin: 0;
  font-family: Segoe UI, sans-serif;
}

.app-type-arrow {
  font-size: 1.4rem;
  color: var(--text-hint-on-background);
  flex-shrink: 0;
  transition: transform 0.18s ease, color 0.18s ease;
}

/* Modal transition */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-active .app-type-modal,
.modal-fade-leave-active .app-type-modal {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .app-type-modal {
  transform: scale(0.95) translateY(8px);
}

.modal-fade-leave-to .app-type-modal {
  transform: scale(0.95) translateY(8px);
  opacity: 0;
}

/* Help modal */
.help-modal {
  position: relative;
  width: 1000px;
  max-width: 90vw;
  height: 600px;
  max-height: 75vh;
}

.help-frame {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.iframe-loader {
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: 10px;
  background: var(--background);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 1.4rem;
  font-weight: 600;
}

@media (max-width: 630px) {
  .app-header {
    --header-pad-x: 0.5rem;
  }

  .hide-on-mobile {
    display: none;
  }

  .new-app-btn {
    font-size: 1.2rem;
    padding: 0 12px;
  }

  .help-modal {
    width: 90vw;
    height: 55vh;
  }
}

/* Dark mode */
.cgsdark .app-header {
  background: var(--kendo-body-bg, #070b14);
}

/* ── Nav Dropdown ── */
.nav-dropdown {
  position: relative;
  align-items: baseline;
}

.nav-dropdown-trigger {
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.nav-chevron {
  font-size: 0.9rem;
  transition: transform 0.15s ease;
  opacity: 0.7;
}

.nav-dropdown:hover .nav-chevron {
  transform: rotate(180deg);
}

.nav-dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 200px;
  background: var(--background);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  z-index: 500;
  padding: 8px 0 5px;
}

.nav-dropdown:hover .nav-dropdown-menu {
  display: block;
}

.nav-dropdown-item {
  display: block;
  padding: 9px 16px;
  text-decoration: none;
  color: var(--primary);
  font-size: 1.5rem;
  font-family: Segoe UI;
  font-weight: 400;
  white-space: nowrap;
  transition: background 0.12s ease;
}

.nav-dropdown-item:hover {
  background: rgba(0, 0, 0, 0.045);
  color: var(--text-secondary-on-background);
}

.nav-dropdown-item.router-link-active {
  color: var(--accent);
  font-weight: 600;
}

/* ── Nested submenu (flyout) — used by swiftComply groups ── */
.nav-submenu {
  position: relative;
}

.nav-submenu-trigger {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.nav-submenu-chevron {
  font-size: 0.9rem;
  opacity: 0.6;
  transition: transform 0.15s ease;
}

.nav-submenu:hover .nav-submenu-chevron {
  transform: translateX(2px);
}

.nav-submenu-menu {
  display: none;
  position: absolute;
  top: -8px;               /* aligns flyout top with parent item */
  left: 100%;
  min-width: 200px;
  background: var(--background);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  z-index: 510;
  padding: 8px 0 5px;
}

.nav-submenu:hover .nav-submenu-menu {
  display: block;
}

.nav-submenu:hover > .nav-submenu-trigger {
  background: rgba(0, 0, 0, 0.045);
  color: var(--text-secondary-on-background);
}

.cgsdark .header-nav {
  background: var(--kendo-body-bg, #070b14);
}

.cgsdark .nav-link {
  color: rgba(226, 232, 240, 0.9);
}

.cgsdark .nav-link:hover {
  color: rgba(226, 232, 240, 0.98);
}

.cgsdark .nav-link.router-link-active {
  color: color-mix(in srgb, var(--accent) 70%, rgba(226, 232, 240, 0.95));
}

.cgsdark .new-app-btn {
  background: rgba(2, 6, 23, 0.55);
  border-color: rgba(148, 163, 184, 0.22);
  color: rgba(226, 232, 240, 0.9);
}

.cgsdark .new-app-btn:hover {
  background: rgba(226, 232, 240, 0.06);
}

.cgsdark .nav-dropdown-menu {
  background: var(--kendo-body-bg, #070b14);
  border-color: rgba(226, 232, 240, 0.12);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
}

.cgsdark .nav-dropdown-item {
  color: rgba(226, 232, 240, 0.9);
}

.cgsdark .nav-dropdown-item:hover {
  background: rgba(226, 232, 240, 0.06);
  color: rgba(226, 232, 240, 0.98);
}

.cgsdark .nav-dropdown-item.router-link-active {
  color: color-mix(in srgb, var(--accent) 70%, rgba(226, 232, 240, 0.95));
}

.cgsdark .app-type-overlay {
  background: rgba(2, 6, 23, 0.7);
}

.cgsdark .app-type-modal {
  background: var(--kendo-body-bg, #070b14);
  border: 1px solid rgba(148, 163, 184, 0.15);
}

.cgsdark .app-type-header {
  border-bottom-color: rgba(148, 163, 184, 0.15);
}

.cgsdark .app-type-title {
  color: rgba(226, 232, 240, 0.95);
}

.cgsdark .app-type-subtitle {
  color: rgba(148, 163, 184, 0.8);
}

.cgsdark .app-type-close {
  color: rgba(148, 163, 184, 0.7);
}

.cgsdark .app-type-close:hover {
  background: rgba(226, 232, 240, 0.06);
  color: rgba(226, 232, 240, 0.9);
}

.cgsdark .app-type-card {
  background: rgba(226, 232, 240, 0.03);
  border-color: rgba(148, 163, 184, 0.18);
}

.cgsdark .app-type-card:hover {
  background: rgba(57, 139, 135, 0.12);
  border-color: var(--accent);
}

.cgsdark .app-type-name {
  color: rgba(226, 232, 240, 0.95);
}

.cgsdark .app-type-desc {
  color: rgba(148, 163, 184, 0.8);
}

.cgsdark .app-type-icon {
  background: rgba(19, 106, 211, 0.15);
  color: var(--primary-mid);
}

.cgsdark .app-type-icon.reverse {
  background: rgba(57, 139, 135, 0.15);
  color: var(--accent-lt);
}

.cgsdark .app-type-icon.commercial {
  background: rgba(148, 163, 184, 0.12);
  color: rgba(226, 232, 240, 0.8);
}

.cgsdark .iframe-loader {
  background: var(--kendo-body-bg, #070b14);
  color: rgba(226, 232, 240, 0.9);
}
</style>